export default __webpack_public_path__ + "48e4b37ecbc5e155460edaea8f531393.woff2";